<template>
    <div>
        <body>
            <!-- header start -->
            <header>
                <div class="container">
                    <nav class="navbar navbar-expand-lg">
                        <a class="navbar-brand" href="#"><img src="@/assets/img/group71.png" alt="tocino" style="max-width: 150%;"></a>
                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon"></span>
                            <span class="navbar-toggler-icon"></span>
                            <span class="navbar-toggler-icon"></span>
                        </button>
                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <div class="nav-btn" style="margin-left: auto;">
                                <a href="https://app.tocino.ai" class="btn btn-login">
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.75 2.75H17.4167C17.9029 2.75 18.3692 2.94315 18.713 3.28697C19.0568 3.63079 19.25 4.0971 19.25 4.58333V17.4167C19.25 17.9029 19.0568 18.3692 18.713 18.713C18.3692 19.0568 17.9029 19.25 17.4167 19.25H13.75" stroke="#FC4141" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9.16699 15.5833L13.7503 11L9.16699 6.41666" stroke="#FC4141" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M13.75 11H2.75" stroke="#FC4141" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>Login
                                </a>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
            <!-- header end -->

            <!-- hero start -->
            <section class="hero" id="sec1">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6 col-md-12">
                            <div class="left-wrapper">
                                <div class="left-hero">
                                    <h1>Tocino te ayuda a<span> autofacturar</span> simplemente toma una foto de tu ticket de compra y ¡listo!</h1>
                                    <p>Utilizando inteligencia artificial, nuestro robot extrae los datos de tu ticket y busca automáticamente la página de facturación del comercio para generar tu factura. Posteriormente, <a href="#">recibirás los archivos XML y PDF directamente en nuestra app.</a></p>
                                </div>
                                <div class="hero-btn">
                                    <!-- <a href="https://app.tocino.ai/registro" class="btn btn-danger">Registrate</a> -->
                                    <a href="https://app.tocino.ai/registro" class="btn btn-danger" style="">Regístrate</a>
                                    <!-- <a href="#" class="btn btn-light"><img src="@/assets/img/app-store.svg" alt=""></a>-->
                                    <a href="https://apps.apple.com/us/app/tocino/id6473308280" class="btn btn-light"><img src="@/assets/img/app-store.svg" alt=""></a>
                                    <a href="https://play.google.com/store/apps/details?id=com.concent.tocino" class="btn btn-light"><img src="@/assets/img/play-store.svg" alt=""></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                            <figure><img src="@/assets/img/hero-main.png" alt="" class="img-fluid"></figure>
                        </div>
                    </div>
                </div>
                <img src="@/assets/img/hero-circle.svg" alt="" class="hero-circle">
                <img src="@/assets/img/hero-rect.svg" alt="" class="hero-rect">
            </section>
            <!-- hero end -->

            <!-- how it works start -->
            <section class="how-it-work" id="sec2">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>¿Cómo funciona?</h2>
                        </div>
                    </div>
                    <div class="work-wrapper">
                        <div class="work-boxes">
                            <div class="image-holder">
                                <img src="@/assets/img/camera.png" alt="">
                            </div>
                            <span>1</span>
                            <p>Toma una foto del ticket</p>
                        </div>  
                        <div class="work-boxes">
                            <div class="image-holder">
                                <img src="@/assets/img/cap.png" alt="">
                            </div>
                            <span>2</span>
                            <p>Nuestra IA hace su magia</p>
                        </div>  
                        <div class="work-boxes">
                            <div class="image-holder">
                                <img src="@/assets/img/invoice.png" alt="">
                            </div>
                            <span>3</span>
                            <p>Nuestro bot crea la factura</p>
                        </div>  
                        <div class="work-boxes">
                            <div class="image-holder">
                                <img src="@/assets/img/drink.png" alt="">
                            </div>
                            <span>4</span>
                            <p>Tómate un café ó té</p>
                        </div>  
                        <div class="work-boxes">
                            <div class="image-holder">
                                <img src="@/assets/img/mbl.png" alt="">
                            </div>
                            <span>5</span>
                            <p>Recibe la factura en Tocino</p>
                        </div>
                    </div>
                </div>
            </section>
            <!-- how it works end -->
            
            <!-- Live demonstration start -->
            <section class="demonstration" id="sec3">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <h3>Demostración en vivo</h3>
                        </div>
                        <div class="col-md-12">
                            <div class="video-main">
                                <video  controls muted>
                                    <source src="https://res.cloudinary.com/clickfactura/video/upload/v1688449704/tocino/tocino_bot.mp4" type="video/mp4">
                                    Tu browser no soporta este video.
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- Live demonstration end -->

            <!-- use cases start -->
            <section class="use-cases" id="sec4">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <h4>Casos de uso</h4>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <div class="cases-detail">
                                <img src="@/assets/img/money-saving.svg" alt="">
                                <div class="cases-inner">
                                    <h5>Deducción de Impuestos</h5>
                                    <p>Aseguraté de pedir todas las facturas de tus compras para poder declararlas y obtener deducibilidad de impuestos.</p>
                                </div>
                            </div>
                        </div>   
                        <div class="col-lg-4 col-md-6">
                            <div class="cases-detail">
                                <img src="@/assets/img/dollar.svg" alt="">
                                <div class="cases-inner">
                                    <h5>Finanzas personales</h5>
                                    <p>No importa si no requieres facturas de tus compras, Tocino te ayuda a llevar un control de tus gastos. Ten visibilidad de cuando, como, cuanto y en que gastas. </p>
                                </div>
                            </div>
                        </div>     
                        <div class="col-lg-4 col-md-6">
                            <div class="cases-detail">
                                <img src="@/assets/img/gurante.svg" alt="">
                                <div class="cases-inner">
                                    <h5>Gastos empresariales</h5>
                                    <p>Lleva el control de lo que gastas a nombre la empresa para solicitar reembolsos ó presentar reportes de gastos.</p>
                                </div>
                            </div>
                        </div>     
                        <div class="col-lg-4 col-md-6">
                            <div class="cases-detail cases-detail-last">
                                <img src="@/assets/img/gurante.svg" alt="">
                                <div class="cases-inner">
                                    <h5>Seguridad y Protección de Datos</h5>
                                    <p>Nuestra IA cuenta con las más avanzadas medidas de seguridad para garantizar la protección de tus datos. La confidencialidad de la información de tus facturas está totalmente resguardada.</p>
                                </div>
                            </div>
                        </div>   
                        <div class="col-lg-4 col-md-6">
                            <div class="cases-detail cases-detail-last">
                                <img src="@/assets/img/money-saving.svg" alt="">
                                <div class="cases-inner">
                                    <h5>Eficiencia Económica</h5>
                                    <p>Al automatizar el proceso de facturación, no solo ahorras tiempo, sino también recursos económicos. Menos horas de trabajo manual significa reducir costos operativos, lo que permite invertir más en el crecimiento de tu negocio.</p>
                                </div>
                            </div>
                        </div>     
                        <div class="col-lg-4 col-md-6">
                            <div class="cases-detail cases-detail-last">
                                <img src="@/assets/img/dollar.svg" alt="">
                                <div class="cases-inner">
                                    <h5>Escalabilidad Empresarial</h5>
                                    <p>Nuestra solución de IA se adapta a las necesidades de tu negocio, sin importar su tamaño. Desde pequeños emprendedores hasta grandes corporaciones, nuestra tecnología es capaz de manejar volúmenes de trabajo de cualquier magnitud, facilitando el crecimiento y la expansión de tu empresa.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- use cases start -->

            <!-- subsciption plans start -->
            <section class="subscription" id="sec5">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <h6>Planes</h6>
                        </div>
                    </div> 
                    <!-- <div class="plans-wrapper">
                        <div class="plans-inner beta">
                            <div class="media">
                                <h5>Early Access</h5>
                                <br>
                                <p>
                                    Actualmente, Tocino ofrece acceso a nuestra IA exclusivamente a través de solicitudes.<br>
                                    Admitiremos a 500 usuarios sin costo mensual, quienes recibirán 10 tickets al mes.<br>
                                    Durante esta etapa inicial, nuestro objetivo principal es refinar nuestra IA y mejorar<br>
                                    la interacción entre los usuarios y los bots.<br>
                                </p>
                                <ul>
                                    <li><img src="@/assets/img/tick.png" alt="">1 RFC</li>
                                    <li><img src="@/assets/img/tick.png" alt="">10 Tickets/mes</li>
                                    <li><img src="@/assets/img/tick.png" alt="">Acceso a todas las funciones</li>  
                                    <li><img src="@/assets/img/tick.png" alt="">Soporte x email</li>
                                    <li><img src="@/assets/img/cross.png" alt="">Acceso a planes de pago</li>
                                </ul>
                                <p class="bottom-pra">Para tener accesso llena el <a href="#sec6">formulario.</a></p>
                            </div>
                        </div>
                    </div> -->
                    <div class="plans-wrapper">
                        <div  v-for="(plan, index) in plans" :key="plan.id" :value="index">
                            <!-- HAY Plan Start -->
                            <div class="plans-inner one" v-if="plan.order == 0">
                                <div class="media">
                                    <h5>{{plan.name}}</h5>
                                    <!-- <ul v-for="feature in plan.features" :key="feature.id">
                                        <li v-if="feature.is_available == true"><img src="@/assets/img/tick.png" alt="">{{feature.feature.feature}}</li>
                                    </ul>
                                    <ul>
                                        <li><img src="@/assets/img/cross.png" alt="">Páginas con captcha</li>      
                                        <li><img src="@/assets/img/cross.png" alt="">Soporte chat/telefónico</li>
                                    </ul> -->
                                    <div v-for="p in plan.plans" :key="p.id">
                                        <div class="form-check" v-if="p.active == true" :class="selected_plan.id == p.id ? 'active' : ''"  @click.prevent="select(p)">
                                            <!-- <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault-5" checked v-if="selected_plan.id == p.id">
                                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault-5" v-else> -->
                                            <label class="form-check-label" for="flexRadioDefault1">
                                                <span>{{p.name}}</span>
                                                <div v-for="property in p.properties" :key="property.id">
                                                     <p><span class="dollar"> ${{ formatNumber(p.amount) }}</span>/mes*</p><br>
                                                    <p><span>{{property.debits}} tickets/mes ||</span> ${{property.extras_cost}}/ticket extra</p><br>
                                                </div>
                                            </label>
                                        </div>
                                        <!-- <div class="subscription-btn" v-if="selected_plan.id == p.id">
                                            <a href="#" class="btn btn-danger">Seleccionar</a>
                                        </div> -->
                                    </div>
                                </div>
                                <p class="pra pra-2">*mas IVA</p>
                            </div> 
                            <!-- Wood Plan Start -->
                            <div class="plans-inner two" v-if="plan.order == 1">
                                <div class="media">
                                    <h5>{{plan.name}}</h5>
                                    <!-- <ul v-for="feature in plan.features" :key="feature.id">
                                        <li v-if="feature.is_available == true"><img src="@/assets/img/tick.png" alt="">{{feature.feature.feature}}</li>
                                    </ul>
                                    <ul>
                                        <li><img src="@/assets/img/cross.png" alt="">Páginas con recaptcha</li>      
                                        <li><img src="@/assets/img/cross.png" alt="">Soporte telefónico</li>
                                    </ul> -->
                                    <div v-for="p in plan.plans" :key="p.id">
                                        <div class="form-check"  v-if="p.active == true" :class="selected_plan.id == p.id ? 'active' : ''"  @click.prevent="select(p)">
                                            <!-- <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault-5" checked v-if="selected_plan.id == p.id">
                                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault-5" v-else> -->
                                            <label class="form-check-label" for="flexRadioDefault-5">
                                                <span>{{p.name}}</span>
                                                <div v-for="property in p.properties" :key="property.id">
                                                    <p><span class="dollar">${{ formatNumber(p.amount) }}</span>/mes*</p><br>
                                                    <p><span>{{property.debits}} tickets/mes ||</span> ${{property.extras_cost}}/tickets extra</p><br>
                                                </div>
                                            </label>
                                        </div>
                                         <!-- <div class="subscription-btn" v-if="selected_plan.id == p.id">
                                            <a href="#" class="btn btn-danger">Seleccionar</a>
                                        </div> -->
                                    </div>
                                </div>
                                <p class="pra">*mas IVA</p>
                                <img src="@/assets/img/brick-rect.svg" alt="" class="brick-rect">
                            </div>
                            <!-- Brick Plan Start -->
                            <div class="plans-inner two" v-if="plan.order == 2">
                                <div class="media">
                                    <h5>{{plan.name}}</h5>
                                    <!-- <ul v-for="feature in plan.features" :key="feature.id">
                                        <li v-if="feature.is_available == true"><img src="@/assets/img/tick.png" alt="">{{feature.feature.feature}}</li>
                                    </ul> -->
                                    <div v-for="p in plan.plans" :key="p.id">
                                        <div class="form-check"  v-if="p.active == true" :class="selected_plan.id == p.id ? 'active' : ''"  @click.prevent="select(p)">
                                            <!-- <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault-5" checked v-if="selected_plan.id == p.id">
                                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault-5" v-else> -->
                                            <label class="form-check-label" for="flexRadioDefault-5">
                                                <span>{{p.name}}</span>
                                                <div v-for="property in p.properties" :key="property.id">
                                                    <p><span class="dollar">${{ formatNumber(p.amount) }}</span>/mes*</p><br>
                                                    <p><span>{{property.debits}} tickets/mes ||</span> ${{property.extras_cost}}/tickets extra</p><br>
                                                </div>
                                            </label>
                                        </div>
                                        <!--  <div class="subscription-btn" v-if="selected_plan.id == p.id">
                                            <a href="#" class="btn btn-danger">Seleccionar</a>
                                        </div> -->
                                    </div>
                                </div>  
                                <p class="pra">*mas IVA</p>
                            </div>
                            <!-- Air Plan Start -->
                            <div class="plans-inner three" v-if="plan.order == 3">
                                <div class="media">
                                    <h5>{{plan.name}}</h5>
                                    <div v-for="p in plan.plans" :key="p.id">
                                        <div class="form-check"  v-if="p.active == true" :class="selected_plan.id == p.id ? 'active' : ''"  @click.prevent="select(p)">
                                            <!-- <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault-5" checked v-if="selected_plan.id == p.id">
                                            <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault-5" v-else> -->
                                            <label class="form-check-label" for="flexRadioDefault-5">
                                                <span>{{p.name}}</span>
                                                <div v-for="property in p.properties" :key="property.id">
                                                    <p><span class="dollar">${{ formatNumber(p.amount) }}</span>/mes*</p><br>
                                                    <p><span>{{property.debits}} tickets/mes</span></p><br>
                                                </div>
                                                <div class="com-box-divider"></div>
                                                <div v-for="range in p.credit_ranges" :key="range.id" class="range-item" style="white-space: nowrap;">
                                                    <span>{{range.start.toLocaleString()}} a {{range.end.toLocaleString()}}</span>
                                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                    <p>${{range.cost}}/ticket extra</p>
                                                </div>
                                                <div v-for="prop in p.properties" :key="prop.id" class="range-item" style="white-space: nowrap;">
                                                    <span>1,000+</span>
                                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                    <p>${{prop.extras_cost}}/ticket extra</p>
                                                </div>
                                            </label>
                                        </div>
                                        <ul v-for="feature in plan.features" :key="feature.id">
                                            <li v-if="feature.is_available == true"><img src="@/assets/img/tick.png" alt="">{{feature.feature.feature}}</li>
                                        </ul>
                                        <!--  <div class="subscription-btn" v-if="selected_plan.id == p.id">
                                            <a href="#" class="btn btn-danger">Seleccionar</a>
                                        </div> -->
                                    </div>
                                    
                                </div>  
                                <p class="pra">*mas IVA</p>
                            </div>
                        </div>
                    </div>
                    <!-- <p class="bottom-pra">Si requieres un paquete especial, por favor <a href="#" data-toggle="modal" data-target="#exampleModal">contactanos</a></p> -->
                </div>
            </section>
            <!-- subsciption end -->

            <!-- contact us start -->
            <section class="contact-us" id="sec6">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <h6>Contáctanos</h6>
                        </div>
                        <div class="col-md-12">
                            <form class="row g-3 needs-validation" novalidate @submit.prevent="help()" ref="form">
                                <div class="mb-3">
                                    <label class="form-label">Nombre completo</label>
                                    <input type="text" class="form-control" placeholder="Chris P. Bacon" v-model="client.name" required>
                                    <div class="invalid-feedback">
                                    Por favor ingresa tu nombre.
                                    </div>
                                </div>     
                                <div class="mb-3">
                                    <label class="form-label">Email</label>
                                    <input type="email" class="form-control" placeholder="chris.p.bacon@tocino.ai" v-model="client.email" required>
                                    <div class="invalid-feedback">
                                    Por favor ingresa tu email.
                                    </div>
                                </div> 
                                <div class="mb-3">
                                    <label class="form-label ">Empresa</label>
                                    <input type="text" class="form-control" placeholder="Los tres cochinitos SA de CV" v-model="client.company" required>
                                    <div class="invalid-feedback">
                                   Por favor ingresa tu empresa.
                                    </div>
                                </div> 
                                <div class="mb-3">
                                    <label for="exampleFormControlInput4" class="form-label">Asunto</label>
                                    <input type="text" class="form-control" id="exampleFormControlInput4" placeholder="Dinos como te podemos ayudar" v-model="client.message">
                                    <div class="invalid-feedback">
                                    Dinos como te podemos ayudar
                                    </div>
                                </div>
                                <div class="subscription-btn contact-us-btn">
                                    <button type="submit" class="btn btn-danger" @click.prevent="help(client)">Enviar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <!-- contact us end -->

            <!-- footer start -->
            <footer>
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="footer-wrapper">
                                <ul>
                                    <li><a href="#"><img src="@/assets/img/group71.png" alt="" style="max-width: 50%;"></a></li> 
                                    <li><a href="#" @click="togglePrivModal">Política de Privacidad</a><PrivModal v-if="showPrivModal" :showPrivModal="showPrivModal" @close="showPrivModal = false" @acceptPriv="acceptPriv"/></li> 
                                    <li><a href="#" @click="toggleModal">Términos y Condiciones de Uso</a><TermsModal v-if="showModal" :showModal="showModal" @close="showModal = false" @acceptTerms="acceptTerms"/></li> 
                                </ul>       
                                <ul>
                                    <li>© Tocino.ai - {{currentYear}}</li> 
                                    <li>
                                       <router-link to="/login">
                                        <a href="https://app.tocino.ai" class="btn btn-login">
                                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.75 2.75H17.4167C17.9029 2.75 18.3692 2.94315 18.713 3.28697C19.0568 3.63079 19.25 4.0971 19.25 4.58333V17.4167C19.25 17.9029 19.0568 18.3692 18.713 18.713C18.3692 19.0568 17.9029 19.25 17.4167 19.25H13.75" stroke="#FC4141" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.16699 15.5833L13.7503 11L9.16699 6.41666" stroke="#FC4141" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M13.75 11H2.75" stroke="#FC4141" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>Login
                                        </a>
                                        </router-link>
                                    </li> 
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <!-- Modal -->
            <!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <section class="contact-us">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h6>Contactanos</h6>
                                        </div>
                                        <div class="col-md-12">
                                            <form >
                                                <div class="mb-3">
                                                    <label class="form-label">Nombre Completo</label>
                                                    <input type="email" class="form-control" id="exampleFormControlInput1" placeholder="Chris P. Bacon" v-model="user.name">
                                                </div>     
                                                <div class="mb-3">
                                                    <label class="form-label">Email</label>
                                                    <input type="email" class="form-control" placeholder="chris.p.bacon@tocino.ai" v-model="client.email">
                                                </div> 
                                                <div class="mb-3">
                                                    <label for="exampleFormControlInput3" class="form-label">Empresa</label>
                                                    <input type="email" class="form-control" id="exampleFormControlInput3" placeholder="Los tres cochinitos SA de CV" v-model="client.company">
                                                </div> 
                                                <div class="mb-3">
                                                    <label for="exampleFormControlInput4" class="form-label">Asunto</label>
                                                    <input type="email" class="form-control" id="exampleFormControlInput4" placeholder="Dinos en que te podemos ayudar" v-model="client.message">
                                                </div>
                                                <div class="subscription-btn contact-us-btn">
                                                    <button type="button" class="btn btn-danger" data-toggle="modal" data-dismiss="modal" data-target="#exampleModal-3">Send</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="exampleModal-4" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-body">
                            <section id="info">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <img src="@/assets/img/check-circle.svg" alt="">
                                            <h2>Recibimos tu información</h2>
                                            <p>En breve te contactaremos.</p>
                                            <div class="subscription-btn contact-us-btn">
                                                <button type="button" class="btn btn-danger" data-dismiss="modal" aria-label="Close">OK</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div> -->
        </body>
    </div>
</template>

<script>
import Plans from '@/api/plans'
import axios from 'axios';
import Swal from 'sweetalert2';
import PrivModal from "../components/PrivModal";
import TermsModal from "../components/TermsModal";

export default {
    data() {
        return {
            plans: [],
            currentYear: new Date().getFullYear(),
            topright: 0,
            bottomright: 0,
            radius: 0,
            topleft: 0,
            bottomleft: 0,
            plan_active: false,
            selected_plan: {},
            client: {
                name: '',
                email: '',
                company: '',
                message: ''
            },
            showPrivModal: false,
            showModal: false
        }
    },
    components: {
        PrivModal,
        TermsModal,
    },
    methods: {
        loadPlans() {
            Plans.get_plans().then((res) => {
                console.log("PLANS", res)
                this.plans = res
            })
        },
        formatNumber(num) {
            return new Intl.NumberFormat('en-US').format(num);
        },
        select(plan) {
             this.selected_plan = plan
        },

        togglePrivModal() {
            this.showPrivModal = true;
        },

        acceptPriv() {
            this.showPrivModal = false;
        },

        toggleModal() {
            this.showModal = true;
        },

        acceptTerms() {
            this.showModal = false;
        },

        async help(client) {
            if (this.client.name !== "" && this.validateEmail(this.client.email) && this.client.company !== "") {
                const isValid = this.$refs.form.checkValidity();
                if (!isValid) {
                    event.preventDefault();
                    event.stopPropagation();
                } else {
                    const data = {
                        personalizations: [{
                            to: [{ email: 'wale@tocino.ai' }],
                            subject: 'Contacto de Landing Page'
                        }],
                        from: { email: 'hola@tocino.ai' },
                        content: [{
                            type: 'text/plain',
                            value: `Nombre: ${client.name}\nEmail: ${client.email}\nEmpresa: ${client.company}\nMessage: ${client.message}`
                        }]
                    };

                    try {
                        Swal.fire({
                            title: 'Enviando mensaje...',
                            text: 'Por favor espera mientras enviamos tus datos.',
                            icon: 'info',
                            showCancelButton: false,
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                            onBeforeOpen: () => {
                                Swal.showLoading();
                            },
                        });

                        await axios({
                            method: 'post',
                            url: '/send-email',
                            data
                        });

                        Swal.close();

                        Swal.fire({
                            icon: 'success',
                            title: 'Mensaje enviado',
                            text: "¡Oh tocino, rico tocino!",
                            type: 'success',
                            confirmButtonText: 'Aceptar'
                        });
                    } catch (error) {
                        Swal.close();
                        Swal.fire({
                            icon: 'error',
                            title: '¡Oink Oink algo salio mal!',
                            text: JSON.stringify(error.response.data),
                            type: 'warning',
                            confirmButtonText: 'Aceptar'
                        });
                    }
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Campos requeridos',
                    text: 'Todos los campos son requeridos y en su formato correcto.',
                    type: 'warning',
                    confirmButtonText: 'Aceptar'
                });
            }
        },
        validateEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
    },
    mounted() {
        this.loadPlans()
    }
}
</script>

<style>
.range-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 1px;
}
.com-box-divider {
    max-width: 100%;
    height: 1px;
    background: #E8EAF0;
    margin: 15px auto;
}
@import '../assets/css/bootstrap.min.css';
@import '../assets/css/responsive.css';
@import '../assets/css/style.css';
</style>
